<template>
<div class="topbar">
    <slot></slot>
</div>
</template>

<script>
import Vue from 'vue';
import { DropdownMenu, DropdownItem } from 'vant';

Vue.use(DropdownMenu);
Vue.use(DropdownItem);

export default {
    data(){
        return {
            
        }
    },
    methods:{
        change(){
            let arr = ['Certification','complaint','person','reward','Salary','service']
            let num = this.getRndInteger(0,5)
            this.$router.push(`./${arr[num]}`)
        },
        getRndInteger(min, max) {
            return Math.floor(Math.random() * (max - min + 1) ) + min;
        }
    }
};
</script>

<style lang="less" scoped>
.topbar {
    height: 40px;
    padding: 24px 5px;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0 0 4px 8px rgb(233, 232, 232);
    margin: 5px 2px;
}
</style>
